import { ChangeEvent } from 'react';

import Component from './component';

export interface Props {
    name: string;
    className?: string;
    value?: string | number;
    onChange: (event: ChangeEvent<any>) => any;
    style?: InputStyles;
    styles?: object;
    error?: string;
    disabled?: boolean;
    required?: boolean;
    label?: string;
    disableDefaultRequiredBehaviour?: boolean;

    expandable?: {
        enabled: boolean;
        label: string;
        triggerText?: string;
    };
}

export enum InputStyles {
    Primary = 'primary',
    Secondary = 'secondary',
    Circle = 'circle',
    Required = 'required',
}

Component.defaultProps = {
    value: '',
    className: '',
    style: InputStyles.Primary,
    styles: {},
    error: null,
    disabled: false,
    expandable: null,
    label: null,
    required: false,
};

export default Component;
